<template>
  <div>
    <v-dialog
      :value="value"
      @input="$emit('input')"
      transition="fade-transition"
      max-width="1250"
      content-class="ims-standard-dialog"
    >
      <v-card class="ims-modal-card">
        <v-card-title class="title ims-modal-header">
          <span class="headline">
            Paired influencers for campaign:
            <strong>{{ campaignCOEB.campaignName }}</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon color="secondary" aria-label="Close" title="Close" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="ims-modal-body">
          <v-row>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Contents</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.min_content }} to {{ campaignCOEB.max_content }}</p>
                    <p class="pa-0 ma-0 custom-font">Current Total: {{measurement.total}}</p>                            
                    <p class="pa-0 ma-0 custom-font" v-if="measurement.totalPercentage && measurement.totalPercentage !== 'NaN' && measurement.totalPercentage !== 'Infinity'">Percentage: {{measurement.totalPercentage}} %</p>           
                    <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Outreach</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.outreach | thousandSeprator}}</p>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Current Total: {{measurement.outreach | thousandSeprator}}</p>
                    <p class="pa-0 ma-0 custom-font" v-if="measurement.outreachPercentage && measurement.outreachPercentage !== 'NaN' && measurement.outreachPercentage !== 'Infinity'">Percentage: {{measurement.outreachPercentage}}%</p>
                    <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Engagement</v-card-title>
                  <v-card-subtitle>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Target : {{ campaignCOEB.engagement | thousandSeprator}}</p>
                    <p
                      class="pa-0 ma-0 custom-font"
                    >Current Total: {{measurement.engagement | thousandSeprator}}</p>         
                    <p class="pa-0 ma-0 custom-font" v-if="measurement.engagementPercentage && measurement.engagementPercentage !== 'NaN' && measurement.engagementPercentage !== 'Infinity'">Percentage: {{measurement.engagementPercentage}}%</p>
                    <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="12" lg="3" md="3" v-if="isNotClientRole">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                >
                  <v-card-title class="headline">Budget</v-card-title>
                  <v-card-subtitle>
                    <p class="pa-0 ma-0 custom-font" v-if="budget">Target : {{ budget | currency }}</p>
                    <p class="pa-0 ma-0 custom-font" v-else>Target : 0</p>
                    <p class="pa-0 ma-0 custom-font">COGS: {{measurement.budget | currency}}</p> 
                    <p
                      class="pa-0 ma-0 custom-font"
                      v-if="measurement.cogsPercentage && measurement.cogsPercentage !== 'NaN' && measurement.cogsPercentage !== 'Infinity'"
                    >Percentage: {{measurement.cogsPercentage}}%</p>
                    <p class="pa-0 ma-0 custom-font" v-else>Percentage: -</p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
          <v-row class="mt-0" style="justify-content:right;">
            <v-col cols="12" sm="3" md="3" lg="3">
              <v-select
                class="input-field pt-3"
                v-model="pairedFilter.payoutStatus"
                :items="payoutStatusOptions"
                item-value="status"
                item-text="display"
                label="Payout Status"
                dense
                outlined
                @change="pairingSearchFilter"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="5" md="5" lg="5">
              <v-text-field
                v-model="pairedFilter.search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="pairedHeaders"
                :items="pairedFilterItems"
                :items-per-page="10"
                :search="pairedFilter.search"
                :no-data-text="'Empty list'"
                class="elevation-1 page__table"
                :key="dataTableKey"
              >
                <template v-slot:body="props">
                  <tbody>
                    <tr
                    v-for="item in props.items"
                    :key="item.instagramHandle"
                    v-bind:class="{'yellow lighten-4': item.payoutSubmitted}">
                      <td>
                        <social-handle
                          divClassName="d-inline"
                          :isTikTok="item.influencer_details.platform === 'tiktok'"
                          :isInstagram="!item.influencer_details.platform || item.influencer_details.platform === 'instagram'"
                          :isYoutube="item.influencer_details.platform === 'youtube'"
                          :isFacebook="item.influencer_details.platform === 'facebook'"
                          :isXiaohongshu="item.platform === 'xiaohongshu'"
                          :isOthers="item.platform === 'others'"
                          :tiktokHandle="item.instagramHandle"
                          :instagramHandle="item.instagramHandle"
                          :youtubeHandle="item.instagramHandle"
                          :facebookHandle="item.instagramHandle"
                          :otherHandle="item.instagramHandle"
                        />
                        <!-- <a :href="'https://www.tiktok.com/@' + item.instagramHandle" target="_blank" v-if="item.influencer_details.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.instagramHandle }}</a>
                        <a :href="'https://instagram.com/' + item.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a> -->
                      </td>
                      <td class="text-center">
                        <span v-if="item.influencer_details.platform === 'facebook'">-</span>
                        <span v-else>{{ item.followers }}</span>
                      </td>
                      <td>
                        <span v-if="item.influencer_details.platform === 'facebook'">-</span>
                        <span v-else>{{ item.engagement_rate }}%</span>
                      </td>
                      <td>
                        <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
                        {{ item.audience_credibility }}
                      </td>
                      <td>{{ item.deliverables }}</td>
                      <td v-if="isNotClientRole">
                        <v-chip class="ma-2" :color="payoutStatusColor(item.payoutStatus)" outlined small>
                          {{ payoutStatusDisplay[item.payoutStatus || 0] }}
                          <v-icon right x-small>mdi-circle-edit-outline</v-icon>
                        </v-chip>
                      </td>
                      <!-- <td>
                        <v-chip
                          class="ma-2"
                          :color="eliminatinStatusColor(item.eliminationStatus)"
                          v-on="on"
                          x-small
                          text-color="white"
                        >
                          {{ eliminationStatusDisplay(item.eliminationStatus) }}
                          <v-icon right x-small>mdi-check</v-icon>
                        </v-chip>
                      </td> -->
                      <td class="text-right" v-if="isNotClientRole">$ {{ item.payoutAmount }}</td>
                      <td class="text-center paired-actions-cell">
                        <div class="paired-actions">
                          <v-tooltip top v-if="buttonShow('editPayout')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                color="secondary"
                                class="paired-action-btn"
                                aria-label="Edit payout"
                                v-bind="attrs"
                                v-on="on"
                                @click="openConfirmPayoutDialog(item)"
                              >
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit payout</span>
                          </v-tooltip>
                          <v-tooltip
                            top
                            v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus !== payoutStatus.CONFIRMED"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                color="primary"
                                class="paired-action-btn"
                                aria-label="Confirm payout"
                                v-bind="attrs"
                                v-on="on"
                                @click="updateSend(item)"
                              >
                                <v-icon small color="secondary">mdi-check</v-icon>
                              </v-btn>
                            </template>
                            <span>Confirm payout</span>
                          </v-tooltip>
                          <v-tooltip
                            top
                            v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus === payoutStatus.CONFIRMED"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                color="error"
                                class="paired-action-btn"
                                aria-label="Cancel payout"
                                v-bind="attrs"
                                v-on="on"
                                @click="cancelPayout(item)"
                              >
                                <v-icon small>mdi-cancel</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancel payout</span>
                          </v-tooltip>
                          <v-tooltip top v-if="buttonPayoutViewShow(item)">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                class="paired-action-btn ims-btn-third"
                                aria-label="View payouts"
                                v-bind="attrs"
                                v-on="on"
                                @click="linkPayoutInternal(item)"
                              >
                                <v-icon small>mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View payouts</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Handle</th>
                <th class="text-left">Followers</th>
                <th class="text-left">Eng. Rate</th>
                <th class="text-left">Aud. Cred</th>
                <th class="text-left">Deliverable Details</th>
                <th class="text-left" v-if="isNotClientRole">Status</th>
                <th class="text-right" v-if="isNotClientRole">Payout Amount</th>
                <th class="text-right" v-if="isNotClientRole">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
              v-for="item in pairedInfluencers"
              :key="item.instagramHandle"
              v-bind:class="{'yellow lighten-4': item.payoutSubmitted}">
                <td>
                  <a :href="'https://www.tiktok.com/@' + item.instagramHandle" target="_blank" v-if="item.influencer_details.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.instagramHandle }}</a>
                  <a :href="'https://instagram.com/' + item.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.instagramHandle }}</a>
                </td>
                <td>{{ item.followers }}</td>
                <td>{{ item.engagement_rate }}%</td>
                <td>
                  <v-icon :color="item.audience_credibility_color">supervised_user_circle</v-icon>
                  {{ item.audience_credibility }}
                </td>
                <td>{{ item.deliverables }}</td>
                <td v-if="isNotClientRole">
                  <v-chip class="ma-2" :color="payoutStatusColor(item.payoutStatus)" outlined small>
                    {{ payoutStatusDisplay[item.payoutStatus || 0] }}
                    <v-icon right x-small>mdi-circle-edit-outline</v-icon>
                  </v-chip>
                </td>
                <td class="text-right" v-if="isNotClientRole">$ {{ item.payoutAmount }}</td>
                <td class="text-center">
                  <v-btn
                    class="ma-1"
                    @click="openConfirmPayoutDialog(item)"
                    color="warning"
                    small
                    v-if="buttonShow('editPayout')"
                  >
                    <v-icon color="white" small>edit</v-icon> Edit Payout
                  </v-btn>
                  <v-btn
                  class="ma-1"
                  v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus !== payoutStatus.CONFIRMED"
                  color="success"
                  small
                  @click="updateSend(item)">
                    <v-icon left>mdi-check</v-icon> Confirm Payout
                  </v-btn>
                  <v-btn
                  class="mb-1"
                  color="error"
                  small
                  @click="cancelPayout(item)"
                  v-if="buttonShow('editPayout') && showConfirmPayout && item.payoutStatus === payoutStatus.CONFIRMED">
                    <v-icon left>mdi-cancel</v-icon> Cancel Payout
                  </v-btn>
                  <v-btn
                  class="ma-1"
                  v-if="buttonPayoutViewShow(item)"
                  @click="linkPayoutInternal(item)"
                  color="warning"
                  dense
                  small>
                    <v-icon left>remove_red_eye</v-icon> View Payouts
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
        <v-card-actions class="ims-modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="close()">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <!-- Campaign Payout Dialog -->
    <payout-confirm-modal  
      v-model="payoutConfirmDialog"
      :value="payoutConfirmDialog"
      :data="payoutConfirmData"
      :influencer="influencer"
      @confirmedPayout="setConfirmedPayout"/>
  </div>
</template>
<script>
import config from '@/config';
import campaignConfig from '../config';
import campaignHelper from '../campaignHelper';
import campaignAPIs from '../campaignAPIs';
import pairingAPIs from '../../Pairing/pairingAPIs';
import SocialHandle from '../../../scoped/custom/SocialHandle'
import PayoutConfirmModal from './PayoutConfirmModal';
import utils from '@/utils';
import reverse from 'lodash/reverse';
export default {
  name: 'PairedInfAdminViewDialog',
  props: [
    'value',
    'campaign',
    'clients'
  ],
  components: {
    SocialHandle,
    PayoutConfirmModal
  },
  data() {
    return {
      payoutStatus: campaignConfig.payoutStatus,
      payoutStatusDisplay: campaignConfig.payoutStatusDisplay,
      pairedHeaders: [
        {
          text: 'Handle',
          value: 'instagramHandle'
        },
        {
          text: 'Followers',
          value: 'followers'
        },
        {
          text: 'Eng. Rate',
          value: 'engagement_rate'
        },
        {
          text: 'Aud. Cred',
          value: 'audience_credibility'
        },
        {
          text: 'Deliverable Details',
          value: 'deliverables'
        },
        {
          text: 'Status',
          value: 'payoutStatus'
        },
        {
          text: 'Payout Amount',
          value: 'payoutAmount'
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      pairedInfluencers: [],
      pairedFilterItems: [],
      pairedFilter: {
        payoutStatus: '',
        search: ''
      },
      payoutConfirmDialog: false,
      payoutConfirmData: {},
      influencer: '',
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      }
    }
  },
  computed: {
    campaignStatus: function () {
      return this.$route.meta.campaignStatus;
    },
    showConfirmPayout: function() {
      return campaignHelper.isAOKCampaign(this.campaignCOEB.campaignType)
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    isNotClientRole: function () {
      // show paired amount except for client side
      return Number(this.$store.state.user.role) !== config.userRoles.CLIENT;
    },
    payoutStatusOptions: function() {
      let data = [];
      Object.entries(this.payoutStatusDisplay).forEach(item => {
        data.push({
          status: item[0],
          display: item[1]
        });
      });
      data.unshift({
        status: '',
        display: 'All'
      });
      return data;
    },
    budget: function() {
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaignCOEB.budget * 0.3)
    },
    markupCOGSAmount: function() {
      let campaignClient = this.clients.find(client => client.id === this.campaignCOEB.clientID)
      return campaignHelper.getMarkupCOGS(this.campaignCOEB.ioNumbers, campaignClient)
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.pairedInfluencers = []
        this.pairedFilterItems = []
        this.getPairedInfluencers(this.campaign)
      }
    }
  },
  methods: {
    async getPairedInfluencers(campaign) {
      const campaignResp = await campaignAPIs.getCampaign(campaign.id)
      if (campaignResp) {
        this.campaignCOEB = Object.assign(
          {},
          {
            id: campaignResp.id,
            campaignId: campaignResp.id,
            campaignName: campaignResp.name,
            campaignType: campaignResp.campaignType,
            companyID: campaignResp.companyID,
            clientID: campaignResp.clientID,
            ioNumbers: campaignResp.ioNumbers,
            campaignOutreach: campaignResp.outreach,
            campaignEngagement: campaignResp.engagement,
            campaignBudget: campaignResp.budget,
            max_content: campaignResp.max_content,
            min_content: campaignResp.min_content,
            outreach: campaignResp.outreach,
            engagement: campaignResp.engagement,
            budget: campaignResp.budget
          }
        )
      }
      const pairingResp = await pairingAPIs.getPairedInfluencersByCampaign(campaign.id)
      if (pairingResp) {
        let items = [];
        for (let data of pairingResp) {
          let inf = this.beautifyData(data);
          // if (inf.eliminationStatus === campaignConfig.eliminationStatus.SELECTED) {
          //   items.push(inf);
          // }
          if (inf.pairingStatus === campaignConfig.pairingStatus.ACCEPTED) {
            items.push(inf);
          }
        }
        this.pairedInfluencers = Object.assign([], items);
        this.campaignMeasurement(items)
        /**
         * #NOTE
         * filter invited influencer list
         */
        const invitedItems = items
        .filter(e => e.pairingStatus !== campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementInvited(invitedItems)

        /**
         * #NOTE
         * filter not invited influencer list
         */
        const notInvitedItems = items
        .filter(e => e.pairingStatus === campaignConfig.pairingStatus.ELIMINATION_PENDING)
        this.campaignMeasurementNotInvited(notInvitedItems)
        this.pairingSearchFilter()
      }
    },
    beautifyData(data) {
      let inf = {};
      const influencerDetails = data.influencer_details;
      const deliverablesDetails = data.deliverables_details || {};
      inf = data.influencer_details;
      inf.influencer_details = utils.func.refreshJSON(influencerDetails)
      inf.pairing_details = data.pairing_details
      inf.elimination_details = data.elimination_details
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.pairingID = data.id;
      inf.id = data.id;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = campaignHelper.getDeliverableDetails(deliverablesDetails)
      if (!inf.userHandle) {
        inf.userHandle = inf.instagramHandle
        inf.influencer_details.userHandle = inf.instagramHandle
      }
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? reverse(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        if (inf.payoutStatus === campaignConfig.payoutStatus.SUBMITTED) {
          inf.payoutSubmitted = true
        }
        if (inf.payoutStatus >= campaignConfig.payoutStatus.CONFIRMED) {
          inf.payoutVerified = true
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details
      }
      return inf;
    },
    campaignMeasurement(items) {
      // console.log('Campaign Outreach', this.campaignCOEB.outreach)
      this.measurement.total = 0
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(item => {
        this.measurement.total += Number(this.calculateContents(item))
        this.measurement.outreach += Number(this.calculateOutreach(item));
        this.measurement.engagement += Number(this.calculateEngagement(item));
        this.measurement.budget += Number(item.payout || 0);
      })
      let content = (this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaignCOEB.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaignCOEB.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.campaignCOEB.budget) * 100).toFixed(2);
    },
    campaignMeasurementInvited(items) {
      this.measurement.invitedTotal = 0
      items.map(item => {
        this.measurement.invitedTotal += Number(this.calculateContents(item))
        this.measurement.invitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.invitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.invitedBudget += Number(item.payout || 0);
      })
    },
    campaignMeasurementNotInvited(items) {
      this.measurement.notInvitedTotal = 0
      items.map(item => {
        this.measurement.notInvitedTotal += Number(this.calculateContents(item))
        this.measurement.notInvitedOutreach += Number(this.calculateOutreach(item));
        this.measurement.notInvitedEngagement += Number(this.calculateEngagement(item));
        this.measurement.notInvitedBudget += Number(item.payout || 0);
      })
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    calculateEngagement(item) {
      const engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return ''
      } else if (status === this.payoutStatus.INCOMPLETE || status === this.payoutStatus.SUBMITTED) {
        return 'warning'
      } else {
        return 'green'
      }
    },
    pairingSearchFilter() {
      this.pairedFilterItems = this.pairedInfluencers.map(i => i)
      if (this.pairedFilter.payoutStatus) {
        this.pairedFilterItems = this.pairedFilterItems.filter(item => parseInt(item.payoutStatus) === parseInt(this.pairedFilter.payoutStatus))
      }
    },
    openConfirmPayoutDialog(item) {
      this.influencer = Object.assign({}, item)
      this.payoutConfirmData = item
      this.invoiceDownload = false
      this.payoutConfirmDialog = true
    },
    setConfirmedPayout(item) {
      this.pairedInfluencers = this.pairedInfluencers.map(p => {
        if (p.pairingID === item.pairingID) {
          p.payoutAmount = item.payout || 0
          p.payout = item.payout || 0
          p.history = item.history
          p.payoutStatus = item.payoutStatus
          if (p.payoutSubmitted) {
            delete p.payoutSubmitted
          }
          if (!p.payoutVerified) {
            p.payoutVerified = true
          }
        }
        return p
      })
    },
    linkPayoutInternal(item) {
      window.open(`/campaignPayoutsInternal?influencerID=${item.influencer_details.influencerID}&campaignID=${item.CampaignID}&verified=true`, '_blank')
    },
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['campaign'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }
      return false;
    },
    buttonPayoutViewShow(item) {
      const buttonPermission = config['userPermissions']['campaign']['viewPayout']
      if (buttonPermission.userRoles.includes(this.currentUserRole) && item.payoutVerified !== undefined) {
        return true
      }
      return false
    },
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style scoped>
.paired-actions-cell {
  min-width: 120px;
  max-width: 160px;
}

.paired-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
}

.paired-action-btn {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// PairedInfAdminViewDialog.vue?84302314